import React, { useEffect, useState } from 'react';
import client from '../../api';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import calculatePercentage from '../../utils/calculatePercentage';
import Percentage from '../../components/Percentage';

const DetailOrder = ({ params }) => {
  const { user } = useSelector(state => state.auth);
  const [detailOrder, setDetailOrder] = useState([]);

  const TotalOrder = [
    {
      name: 'Waiting',
      total: detailOrder?.waiting,
      className: 'waiting'
    },
    {
      name: 'On The Way',
      total: detailOrder?.otw,
      className: 'otw'
    },
    {
      name: 'Completed',
      total: detailOrder?.completed,
      className: 'completed'
    },
    {
      name: 'Cancel',
      total: detailOrder?.cancel,
      className: 'cancel'
    }
  ];

  const getData = async () => {
    const response = await client.get(`/api/customers/dashboard/detail-order`, {
      params,
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${user.data.token}`
      }
    });
    return response.data;
  };

  useEffect(() => {
    getData(params)
      .then(value => {
        setDetailOrder(value);
      })
      .catch(() => toast.error('Internal Server Error'));
  }, [params]);

  return (
    <div className='dashboard-panel'>
      <div className='dashboard-panel__head'>
        <h3 className='dashboard-panel__title'>Detail Order</h3>
        <p className='dashboard-panel__subtitle'>
          Status order pada periode terpilih
        </p>
      </div>

      <div className='dashboard-kpi'>
        <div className='dashboard-kpi__item'>
          <p className='dashboard-kpi__label'>Total order</p>
          <p className='dashboard-kpi__value'>
            {detailOrder?.total_orders ?? 0}
          </p>
        </div>
        <div className='dashboard-kpi__item'>
          <p className='dashboard-kpi__label'>Nilai</p>
          <p className='dashboard-kpi__value dashboard-kpi__value--sm'>
            {detailOrder?.total_offer_price ?? '-'}
          </p>
        </div>
      </div>

      <div className='dashboard-status'>
        {TotalOrder.map((row, index) => {
          const pct =
            calculatePercentage(row?.total, detailOrder?.total_orders) || 0;
          return (
            <div className='dashboard-status__row' key={index}>
              <span className={`dashboard-status__dot ${row.className}`} />
              <p className='dashboard-status__name'>{row.name}</p>
              <p className='dashboard-status__count'>{row.total ?? 0}</p>
              <Percentage value={pct} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DetailOrder;
